<template>
    <div>
        <li class="header">NAVIGASI UTAMA</li>

            <li class="active">
                <router-link to="/sakip">
                    <i class="material-icons">home</i>
                    <span>Home</span>
                </router-link>
            </li>
            <li v-if="cek_menu_Delegasi_Kinerja()">
                <a href="javascript:void(0);" class="menu-toggle">
                    <i class="material-icons col-green">assignment_turned_in</i>
                    <span>Delegasi Kinerja</span>
                </a>
                <ul class="ml-menu">
                    <li v-if="level_akses_simpeg.delegasi_lv_1">
                        <router-link to="/sakip_pk_lv_1">Delegasi Level-I (Program)</router-link>
                    </li>
                    <li v-if="level_akses_simpeg.delegasi_lv_2">
                        <router-link to="/sakip_pk_lv_2">Delegasi Level-II (Kegiatan)</router-link>
                    </li>
                    <!-- <li v-if="level_akses_simpeg.delegasi_lv_3">
                        <router-link to="/sakip_pk_lv_3">Delegasi Level-III</router-link>
                    </li>
                    <li>
                        <router-link to="/sakip_pk_lv_4">Delegasi Level-IV</router-link>
                    </li> -->
                </ul>
            </li>
            <li v-if="cek_menu_rencana_aksi()">
                <a href="javascript:void(0);" class="menu-toggle">
                    <i class="material-icons col-green">book</i>
                    <span>Rencana Aksi</span>
                </a>
                <ul class="ml-menu">
                    <li v-if="level_akses_simpeg.ra_lv_1">
                        <router-link to="/sakip_ra_lv_1">Target Rencana Aksi (Pimpinan)</router-link>
                    </li>
                    <!-- <li v-if="level_akses_simpeg.ra_lv_2">
                        <router-link to="/sakip_ra_lv_2">Rencana Aksi Level-II</router-link>
                    </li> -->
                    <!-- <li v-if="level_akses_simpeg.ra_lv_3">
                        <router-link to="/sakip_ra_lv_3">Rencana Aksi Level-III</router-link>
                    </li>
                    <li>
                        <router-link to="/sakip_ra_lv_4">Rencana Aksi Level-IV</router-link>
                    </li> -->
                </ul>
            </li>
            <li>
                <a href="javascript:void(0);" class="menu-toggle">
                    <i class="material-icons col-green">book</i>
                    <span>Realisasi</span>
                </a>
                <ul class="ml-menu">
                    <li >
                        <router-link to="/sakip_realisasi_kinerja_keuangan">Realisasi Kinerja & Keuangan</router-link>
                    </li>
                    <li >
                        <router-link to="/sakip_iku_daerah">IKU Daerah</router-link>
                    </li>
                    <li >
                        <router-link to="/sakip_iku_opd">IKU OPD</router-link>
                    </li>
                    <li >
                        <router-link to="/sakip_evaluasi_kinerja">Evaluasi Kinerja</router-link>
                    </li>
                </ul>
            </li>
            <!-- <li v-if="level_akses_simpeg.realisasi">
                <router-link to="/sakip_realisasi_kinerja_keuangan">
                    <i class="material-icons col-green">assessment</i>
                    <span>Realisasi Kinerja & Keuangan</span>
                </router-link>
            </li> -->

            <li v-if="cek_menu_laporan()">
                <a href="javascript:void(0);" class="menu-toggle">
                    <i class="material-icons col-green">assignment</i>
                    <span>Laporan</span>
                </a>
                <ul class="ml-menu">

                    <li>
                        <a href="javascript:void(0);" @click="hover_submenu('sakip_perencanaan')">
                            <b>Perencanaan Daerah</b>
                            <div class="sakip_perencanaan tempat_icon"><i class="material-icons icon_add">add</i></div>
                        </a>
                        <ul class="subsubmenux" id="sakip_perencanaan">
                            <li >
                                <router-link to="/sakip_lap_perencanaan">RPJMD</router-link>
                            </li>
                            <li>
                                <router-link to="/planing_indikator_kinerja">IKU</router-link>
                            </li>
                            <!-- <li>
                                <router-link to="/planing_rkpd_prioritas_daerah">Pelaporan</router-link>
                            </li> -->
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0);" @click="hover_submenu('sakip_perencanaan_opd')">
                            <b>Perencanaan OPD</b>
                            <div class="sakip_perencanaan_opd tempat_icon"><i class="material-icons icon_add">add</i></div>
                        </a>
                        <ul class="subsubmenux" id="sakip_perencanaan_opd">
                            <li >
                                <router-link to="/planing_laporan_renstra">Visi-Misi-Tujuan-sasaran</router-link>
                            </li>
                            <li>
                                <router-link to="/planing_laporan_sasaran_program">Sasaran-Program</router-link>
                            </li>
                            <!-- <li>
                                <router-link to="/planing_rkpd_prioritas_daerah">Pelaporan</router-link>
                            </li> -->
                        </ul>
                    </li>



                    <li  v-if="level_akses_simpeg.laporan">
                        <!-- <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Laporan Perjanjian Kinerja</a> -->
                        <router-link to="/sakip_lap_perjanjian_kinerja">Laporan Perjanjian Kinerja</router-link>
                    </li>
                    <li  v-if="level_akses_simpeg.laporan">
                        <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Laporan Rencana Aksi</a>
                        <!-- <router-link to="/sakip_lap_rencana_aksi">Laporan Rencana Aksi</router-link> -->
                    </li>
                    <li  v-if="level_akses_simpeg.laporan">
                        <!-- <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Laporan Rencana Aksi</a> -->
                        <router-link to="/sakip_lap_monev">Laporan Evaluasi</router-link>
                    </li>
                    <li  v-if="level_akses_simpeg.laporan">
                        <!-- <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Laporan Rencana Aksi</a> -->
                        <router-link to="/sakip_lap_pohon_kinerja">Pohon Kinerja</router-link>
                    </li>
                </ul>
            </li>

 


            <li class="header">DATA MASTER</li>
            <li>
                <a href="javascript:void(0);" class="menu-toggle">
                    <i class="material-icons col-deep-orange">assignment_returned</i>
                    <span>Data Master</span>
                </a>
                <ul class="ml-menu">
                    <li>
                        <!-- <a @click="alertku('error', 'Anda tidak dapat menuju page ini, silahkan hub. Administrator!')">Jabatan</a> -->
                        <router-link to="/simpeg_jabatan">Jabatan</router-link>
                    </li>
                    <li>
                        <a @click="alertku('error', 'Anda tidak dapat menuju page ini, silahkan hub. Administrator!')">Tupoksi</a>
                        <!-- <router-link to="/office_borang_acu">Tupoksi</router-link> -->
                    </li>
                    <li >
                        <a @click="alertku('error', 'Anda tidak dapat menuju page ini, silahkan hub. Administrator!')">Kepegawaian</a>
                        <!-- <router-link to="/office_borang_acu">Kepegawaian</router-link> -->
                    </li>

                </ul>
            </li>
            

            <li>
                <a href="javascript:void(0);">
                    <i class="material-icons col-amber">settings</i>
                    <span>Pengaturan</span>
                </a>
            </li>

    </div>
</template>


<script>
const ADD_URL_LEVEL_SAKIP = URL_APP + 'api/v1/reg_modul_sakip/';
export default {
    data (){
        return{
            id_user : '',
            level_akses_simpeg : {
              
            }
        }
    },
    methods: {
        getLevelSakip : function(){
            fetch(ADD_URL_LEVEL_SAKIP +'get_one',{
                method : 'POST',
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : 'id'
                })
            })
            .then(res => res.json())
            .then(res_data => {
                // console.log('telasooooooooo');
                // console.log(res_data);
                this.level_akses_simpeg = res_data;
                // localStorage.level = JSON.stringify(res_data);
                // console.log(this.level_akses_simpeg);
            });
        },
        cek_menu_Delegasi_Kinerja(){
            var data = this.level_akses_simpeg;
            if (
                data.delegasi_lv_1 == 0 &&
                data.delegasi_lv_2 == 0 &&
                data.delegasi_lv_3 == 0
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        cek_menu_rencana_aksi(){
            var data = this.level_akses_simpeg;
            if (
                data.ra_lv_1 == 0 &&
                data.ra_lv_2 == 0 &&
                data.ra_lv_3 == 0 
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        cek_menu_laporan(){
            var data = this.level_akses_simpeg;
            if (
                data.laporan == 0 
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },

        hover_submenu : function(data){

            if ($('#'+data+'').is(':visible')){
                $('#'+data+'').hide('');
                $('.'+data+'').empty();
                $('.'+data+'').append('<i class="material-icons icon_add">add</i>');
            }
            else{
                $('#'+data+'').show('');
                $('.'+data+'').empty();
                $('.'+data+'').append('<i class="material-icons icon_add">remove</i>');
            }

        },
        alertku : function(type, title){
            this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 1800
            });
        },

        
    },
    mounted() {

        var get_profile = JSON.parse(localStorage.profile);
        this.id_user = get_profile._id
        this.getLevelSakip();

    },

}
</script>

<style>

</style>
